export var LineItemSourceType = /*#__PURE__*/ function(LineItemSourceType) {
    LineItemSourceType["Custom"] = "CUSTOM";
    LineItemSourceType["FromInvoice"] = "FROM_INVOICE";
    return LineItemSourceType;
}({});
